import { useRef, useState } from 'react';

import { ChevronRight } from 'lucide-react';
import { IconButton } from '../buttons/IconButton';

const ExpandingDropdown = ({ label, children, indent = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);

    const element = contentRef.current;
    if (!element) return;

    if (!isOpen) {
      element.style.maxHeight = element.scrollHeight + 'px';
    } else {
      element.style.maxHeight = 0;
    }
  };

  return (
    <div className="flex flex-col">
      <IconButton
        LeftIcon={
          <ChevronRight
            className={`transition-transform duration-300 ease-in-out w-6 ${
              isOpen ? 'rotate-90' : 'rotate-0'
            }`}
          />
        }
        label={label}
        className="mb-2"
        onClick={toggleDropdown}
      />
      <div
        ref={contentRef}
        className={`overflow-hidden transition-all duration-300 ease-in-out max-h-0 ${
          indent ? 'ml-6' : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export { ExpandingDropdown };
